import { combineReducers } from 'redux';
import { authReducer } from '@ipc/ipc-core';
import notificationReducers from './notificationReducer';

export default combineReducers({
  auth: authReducer,
  notifications: notificationReducers,
});
